import { CustomerProfile } from '@/models';
import { Campaign, GroupCampaign } from '@/models/reward';
import { ExtraOptinEvent } from '@/services/analytics/events/extra-optin-event';
import { AnalyticsEventType } from '@/services/analytics/platforms/adobe-analytics/models';
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';

@Component({
  name: 'CmgRewardsExtrasBody',
})
export default class CmgRewardsExtrasBody extends Vue {
    @Prop({ required: true, type: Array })
    campaigns!: Campaign[];

    @Prop({ required: true, type: Array })
    groupCampaigns!: GroupCampaign[];

    mounted() {
      this.$services.featureFlags.refreshApimFeatureFlags();
      this.$services.analytics.send(new ExtraOptinEvent(AnalyticsEventType.PageLoaded));
    }

    get customer(): CustomerProfile | null {
      return this.$appStore.state.customer.profile;
    }    

    get isUserOptedIntoExtras(): boolean {
      return this.customer?.optedIntoExtras || false;
    }

    get isSummerOfExtrasEnabled(): boolean {
      return this.$appStore.state.featureFlags.featureFlags.isSummerOfExtrasEnabled;
    }

    get hasCampaigns(): boolean {
        return this.displayCampaigns.length > 0 || this.summerExtraCampaign != null;
    }

    get isSummerLeaderboardOnline(): boolean {
      return  this.summerExtraCampaign != null;
    }
  
    get summerExtraCampaign(): Campaign | undefined {
      return this.campaigns.find(c => c.campaignType === 'summerExtra' && c.isMultiStepCampaign === false);
    }

    get displayCampaigns(): any[] {
      const campaignArray = [];
      if (this.groupCampaigns.length < 1) {
        campaignArray.push(...this.campaigns);
      } else {
        campaignArray.push(...this.campaigns, ...this.groupCampaigns);
      }
      return campaignArray.filter(x => x.campaignType?.toLowerCase() !== 'summerextra' ).sort((a, b) => (a.endDate! < b.endDate! ? -1: 1));
    }

    get description(): string {
      return 'There aren\'t any Extras challenges available right now, but check back soon for ways to earn extra points.';
    }

    get howToImage1Url(): string {
      return this.$appStore.state.cms.images.icons.extrasHowTo1.default;
    }

    get howToImage2Url(): string {
      return this.$appStore.state.cms.images.icons.extrasHowTo2.default;
    }

    get howToImage3Url(): string {
      return this.$appStore.state.cms.images.icons.extrasHowTo3.default;
    }
}
